import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AgGridModule } from 'ag-grid-angular';
import { MyDatePickerModule } from 'mydatepicker';
import { TextMaskModule } from "angular2-text-mask";
import { CallTypeService } from "../../core/services/call-type.service";
import { DepotService } from '../../core/services/depot.service';
import { DriverService } from '../../core/services/driver.service';
import { PayorService } from '../../core/services/payor.service';
import { PlanService } from '../../core/services/plan.service';
import { RiderAdminuserService } from '../../core/services/rider-adminuser.service';
import { RiderNotesInformationService } from '../../core/services/rider-notes-information.service';
import { RiderPayorDetailService } from "../../core/services/rider-payor-detail.service";
import { RiderPayorService } from '../../core/services/rider-payor.service';
import { RiderService } from '../../core/services/rider.service';
import { DirectivesModule } from "../../directives/directives.module";
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { ChangePasswordModule } from '../A2-utils/change-password/change-password.module';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { ViewAttachmentFileComponent } from '../A2-utils/grid-components/view-attachment-file/view-attachment-file.component';
import { SearchLocationTripModule } from '../A2-utils/search-location-trip/search-location-trip.module';
import { RidersModule } from "../riders/riders.module";
import { AddPayorExpressComponent } from './components/add-payor-express/add-payor-express.component';
import { RiderCurrentResidenceComponent } from './components/rider-current-residence/rider-current-residence.component';
import { RiderFormComponent } from './components/rider-form/rider-form.component';
import { RiderHistoryComponent } from './components/rider-history/rider-history.component';
import { RiderInformationComponent } from './components/rider-information/rider-information.component';
import { RiderIvrInformationComponent } from './components/rider-ivr-information/rider-ivr-information.component';
import { RiderMobileAppComponent } from './components/rider-mobile-app/rider-mobile-app.component';
import { CreateNoteComponent } from './components/rider-notes-information/create-note/create-note.component';
import { RiderNotesComponent } from './components/rider-notes-information/rider-notes.component';
import { RiderSignaturesComponent } from './components/rider-signatures/rider-signatures.component';
import { RiderPayorDetailGridComponent } from './components/rider-payor-detail-grid/rider-payor-detail-grid.component';
import { RiderPayorDetailComponent } from './components/rider-payor-detail/rider-payor-detail.component';
import { RiderPayorGridComponent } from './components/rider-payor-grid/rider-payor-grid.component';
import { RiderPayorComponent } from './components/rider-payor/rider-payor.component';
import { RiderRoutingModule } from './rider-routing.module';
import { AditionalPayorService } from './services/aditional-payor.service';
import {MergeAccountModule} from '../merge-account/merge-account.module';
import { RiderAlertsComponent } from './components/rider-alerts/rider-alerts.component';
import { CreateRiderAlertsComponent } from './components/create-rider-alerts/create-rider-alerts.component';
import { RiderAlertService } from './services/rider-alert.service';
import { ViewRiderAlertComponent } from './components/view-rider-alert/view-rider-alert.component';
import {RiderQrCodeModule} from './components/rider-qr-code/rider-qr-code.module';
import { SsnModuleModule } from '../../utils/ssn-module/ssn-module.module';
import { ExcludeProvidersModule } from 'app/utils/exclude-providers/exclude-providers.module';
import { PhoneNumberModule } from 'app/utils/phone-number/phone-number.module';

@NgModule({
    imports: [
        CommonModule,
        RiderRoutingModule,
        DirectivesModule,
        ReactiveFormsModule,
        MyDatePickerModule,
        AgGridModule.withComponents([
          BooleanCheckComponent,
          ViewAttachmentFileComponent
        ]),
        TextMaskModule,
        Trip2ThemeModule,
        SearchLocationTripModule,
        RidersModule,
        FormsModule,
        ChangePasswordModule,
        MergeAccountModule,
        RiderQrCodeModule,
        SsnModuleModule,
        ExcludeProvidersModule,
        PhoneNumberModule
    ],
  exports: [
    RiderFormComponent,
    ViewRiderAlertComponent,
  ],
  providers: [
    CallTypeService,
    RiderAdminuserService,
    RiderPayorService,
    RiderService,
    PayorService,
    RiderPayorDetailService,
    PlanService,
    DriverService,
    DepotService,
    RiderNotesInformationService,
    AditionalPayorService,
    RiderAlertService
  ],
  declarations: [
    RiderFormComponent,
    RiderInformationComponent,
    RiderPayorComponent,
    RiderCurrentResidenceComponent,
    RiderPayorDetailComponent,
    RiderPayorGridComponent,
    RiderPayorDetailGridComponent,
    RiderIvrInformationComponent,
    RiderHistoryComponent,
    RiderMobileAppComponent,
    RiderNotesComponent,
    RiderSignaturesComponent,
    CreateNoteComponent,
    AddPayorExpressComponent,
    RiderAlertsComponent,
    CreateRiderAlertsComponent,
    ViewRiderAlertComponent]
})
export class RiderModule { }



// WEBPACK FOOTER //
// ./src/app/pages/rider/rider.module.ts